/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Emulation API
 * work with virtual devices
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    Errors,
} from './';

/**
 * encoded information
 * @export
 * @interface RegularResponseStruct
 */
export interface RegularResponseStruct {
    /**
     * @type {number}
     * @memberof RegularResponseStruct
     */
    voltage?: number;
    /**
     * @type {string}
     * @memberof RegularResponseStruct
     */
    occupation_status?: RegularResponseStructOccupationStatusEnum;
    /**
     * @type {number}
     * @memberof RegularResponseStruct
     */
    previous_occupancy_status_duration_min?: number;
    /**
     * @type {Array<Errors>}
     * @memberof RegularResponseStruct
     */
    errors?: Array<Errors>;
}

/**
 * @export
 * @enum {string}
 */
export enum RegularResponseStructOccupationStatusEnum {
    Free = 'Free',
    Occupied = 'Occupied'
}

